import axiosIns from '@/api/axios'

export const GET_LIST = () => {
  return axiosIns.get("/presence");
};

export const DETAIL = (id) => {
  return axiosIns.get(`/presence/${id}`);
};